module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAPCAYAAADZCo4zAAAAsUlEQVQoU3XRzQoBYRTG8f9zIa6EBYMSZUHJlVjbs5BiZ8mCbJWUrF2KcAuPZnpHY2a8y3N+nfd8yPYdmEo6UfJkOwKOwFjSOW8UBzJoJOmSRQkIqA3sgaGkaxr/gn/oBwTUAXbAQNKtAALqAlugXwoCOgCVfxVmQA9olPUwB+I+IkmP/BQLoJUm46+ye1gC9ZB8/uzB9gqoAU1J32RSwfYaqCYNSe/CLWxPgI2kV9k1P23tSCMbqrRCAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/common/images/index/back2.png
// module id = IJjP
// module chunks = 0